import React, { useState } from 'react';
import useLocalisation from './useLocalisation';

function useEvents() {
  const [selectedEvent, setSelectedEvent] = useState();
  const [eventTime, setEventTime] = useState();

  const EventSelector = ({ events = {}, language = 'fi' }) => {
    const { localize, toLocalisationKey } = useLocalisation(language);
    const handleSelectEvents = ({ data }, timeString) => {
      setEventTime(timeString);
      setSelectedEvent(data);
    };

    const keys = Object.keys(events);

    if (!keys.length) return <p>{localize('NO_EVENTS')}</p>;
    return keys.map((key) => (
      <div
        style={{
          display: 'flex',
          margin: '.8rem',
          padding: '.8rem',
          border: 'solid 2px',
          borderColor: 'var(--color-brown)',
          color:
            key === eventTime ? 'var(--color-white)' : 'var(--color-black)',
          cursor: 'pointer',
          background: key === eventTime ? 'var(--color-brown)' : 'transparent',
        }}
        key={key}
        role="button"
        onClick={() => handleSelectEvents(events[key], key)}
      >
        {events[key].data.map((d) => (
          <div
            style={{
              display: 'flex',
              flex: 1,
              flexFlow: 'column',
              fontSize: '1rem',
            }}
            key={d.eventType}
          >
            <p style={{ fontWeight: 'bold' }}>{d.slot}</p>
            <p>
              {d.eventType.split('-')[0] == 'custom'
                ? d.eventTitle
                : localize(toLocalisationKey(d.eventTitle))}{' '}
              ({d.freeSpots} {localize('SPOTS')})
            </p>
          </div>
        ))}
      </div>
    ));
  };

  const clearEventData = () => {
    setSelectedEvent(null);
    setEventTime(null);
  };

  return { selectedEvent, eventTime, clearEventData, EventSelector };
}

export default useEvents;
